module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-Book-6a30582053d39f00519036f873164c2f.svg";